<template>
  <div id="top-bar-component">
    <v-app-bar flat absolute  :height="$vuetify.display.xs ? 56 : 76"  class="first-top-bar px-xs-2 px-sm-5 px-md-10">
      <v-btn
        v-if="$vuetify.display.xs"
        @click="toggleSidemenu()"
        class="mx-1"
        height="48px"
        width="48px"
        elevation=0
        size="large"
        icon tile
      >
        <v-icon class="mr-0" size="28px">mdi-view-split-horizontal</v-icon>
      </v-btn>

      <router-link v-bind:to="getHeaderLink" class="main-logo mx-1">
        <img v-if="this.getDarkMode" src="../../assets/images/tw-main-logo-dark.png" :alt="$t('menus.topBars.home')" />
        <img v-if="!this.getDarkMode" src="../../assets/images/tw-main-logo-light.png" :alt="$t('menus.topBars.home')" />
      </router-link>

      <v-spacer />

      <v-btn
        v-if="showingBackToApp"
        class="mx-1 bg-primary"
        elevation=0
        to="/"
      >
        <v-icon>mdi-backburger</v-icon>
        <span class="hidden-xs">
          {{$t('layouts.main.backToApp')}}
        </span>
      </v-btn>

      <NotificationsMenu v-if="!isTenantSubscriptionExpired" />
      <BeeUserMenu />

    </v-app-bar>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import BeeUserMenu from '../mainLayout/components/topBars/BeeUserMenu.vue';
import NotificationsMenu from '../mainLayout/components/topBars/notifications/NotificationsMenu.vue'

export default {
  name: "TopBar",
  components: {
    BeeUserMenu,
    NotificationsMenu,
  },
  methods: {
    toggleSidemenu() {
      const mainStore = useMainStore();
      mainStore.toggleSidemenu();
    },
  },
  computed: {
    getDarkMode() {
      const mainStore = useMainStore();
      return mainStore.getDarkMode;
    },
    getHeaderLink: function() {
      return '/console/index';
    },
    getRootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    isTenantSubscriptionExpired() {
      const authStore = useAuthStore();
      return authStore.tenantIsExpired;
    },
    showingBackToApp: function() {
      return !this.isTenantSubscriptionExpired && this.getRootNodeId;
    },
  }
}
</script>

<style>
</style>
